import { Link, createFileRoute, notFound } from "@tanstack/react-router";

import { notFoundStatus } from "@/lib/http-status";
import { ogImageMeta } from "@/lib/og";

/**
 * Catch-all route: onbekende URL's geven een echte HTTP 404-status terug,
 * zodat zoekmachines geen soft-404 zien.
 */
export const Route = createFileRoute("/$")({
  loader: async () => {
    await notFoundStatus();
    throw notFound();
  },
  head: () => ({
    meta: [
      { title: "Pagina niet gevonden (404) | CasinoBetalingen.com" },
      {
        name: "description",
        content:
          "Deze pagina bestaat niet (meer). Bekijk de betaalmethoden of gebruik de casinozoeker om casino's op jouw betaalmethode te vergelijken. 18+.",
      },
      { name: "robots", content: "noindex, follow" },
      { property: "og:title", content: "Pagina niet gevonden (404) | Casino Betalingen" },
      {
        property: "og:description",
        content: "Deze pagina bestaat niet (meer). Vergelijk casino's op betaalmethode.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      ...ogImageMeta("default"),
    ],
  }),
  component: NotFoundPage,
  notFoundComponent: NotFoundPage,
});

function NotFoundPage() {
  return (
    <main className="mx-auto flex min-h-[60vh] max-w-3xl flex-col items-center justify-center px-4 text-center">
      <p className="font-display text-6xl font-bold text-primary">404</p>
      <h1 className="mt-4 text-2xl font-semibold text-foreground">
        Deze pagina bestaat niet (meer)
      </h1>
      <p className="mt-2 text-muted-foreground">
        Mogelijk is de pagina verplaatst. Bekijk de betaalmethoden of gebruik de casinozoeker.
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/betaalmethoden/"
          className="inline-flex items-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
        >
          Alle betaalmethoden
        </Link>
        <Link
          to="/casinozoeker/"
          className="inline-flex items-center rounded-md border border-input px-4 py-2 text-sm font-medium text-foreground hover:bg-accent"
        >
          Casinozoeker
        </Link>
      </div>
    </main>
  );
}
